import React, { Component } from "react";
import { Button } from "reactstrap";
import { connect } from "react-redux";
import dot1 from "../../assets/images/png/MaskGroup101.png";
import ErrorPopup from "../Components/ErrorPopup";
import SweetAlert from "react-bootstrap-sweetalert";
import * as Sentry from "@sentry/react";
import contactus from "../../assets/images/png/contactus.png";
import eventEmitter from "../ReusableComponent/EventEmitter";

const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
  };
};

class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: props?.reduxData?.loginDetails?.user?.username,
      subscriptionLevel: "",
      openErrorPopup: false
    };
  }

  componentDidMount() {
    const loginSubs = this.props?.reduxData?.loginSubscriptionDetail;
    const activeSubscription = Array.isArray(loginSubs)
      ? (loginSubs.find(item => item.attributes?.active === true) || { id: 0 })
      : { id: 0 };
    this.setState({ subscriptionLevel: activeSubscription?.attributes?.plan?.toLowerCase() })
  }

  getStartedClicked = (id) => {
    if (id === "1") {
      console.log("id 1 clicked")
      this.props?.history?.push({ pathname: '/app/cancerType' })
    } else if (id === "2") {
      console.log("id 2 clicked")
      this.props?.history?.push({ pathname: '/app/discover/myProject' })
      // if (this.state.subscriptionLevel === "gold") {
      //   this.props?.history?.push({ pathname: '/app/discover/myProject' })
      // } else {
      //   this.setState({ openErrorPopup: true });
      // }
    } else if (id === "3") {
      console.log("id 3 clicked")
      this.props?.history?.push({ pathname: '/app/discover/discover&Repurposing' })
      // if(this.state.subscriptionLevel === "gold"){
      //   this.props?.history?.push({ pathname: '/app/discover/discover&Repurposing' })
      // } else {
      //   this.setState({ openErrorPopup: true });
      // }
    } else if (id === "6") {
      console.log("id form clicked")
      this.props?.history?.push({ pathname: '/app/forum' })
    } else if (id === "4") {
      console.log("id 4 clicked")
      this.props?.history?.push({ pathname: '/app/biomarker-drug-discovery' })
    }else if (id === "5") {
      console.log("id 5 clicked")
      this.props?.history?.push({ pathname: '/app/populationProjection' })
    }
  };

  closePopup = () => {
    this.setState({ openErrorPopup: false });
  };

  handleError = () => {
    try {
      throw new Error("This is a test issue from React!");
    } catch (error) {
      Sentry.captureException(error);
      console.error("Error sent to Sentry:", error);
    }
  };

  render() {
    const { userName } = this.state;
    const cardData = [
      {
        id: "1",
        heading: "Drug Repositioning Database",
        description:
          "A Web Portal for AI-based Comprehensive Discovery of Repositioning Drugs",
      },
      {
        id: "4",
        heading: "Biomarker and Drug Discovery",
        description:
          "Cloud Software Solution for Cancer Biomarker Discovery and Drug Development",
      },
      {
        id: "2",
        heading: "Clinical Decision Making",
        description:
          "AI-based patient matching, treatment protocol selection, and outcome prediction for personalized clinical decision support.",
      },
      {
        id: "6",
        heading: "Forum",
        description:
          "Join discussions and collaborate with peers.",
      },
    ];

    return (
      <div className="landing-main"   >
        <div className="landing-top">
          <div className="landing-left">
            <img src={dot1} alt="Decoration" />
          </div>
          <div className="landing-content">
            <div className="heading-landing">Hello {userName.split(' ')[0]}, Welcome to CATOS-AI</div>
            <div className="heading-description">
              <div className="description-inner">
                An AI-driven software tool designed for optimal cancer treatment selection
                and new/repositioning drug discovery

              </div>
            </div>
            {/* <div style={{ marginTop: '20px' }}>
              <Button
                color="primary"
                className="ai-chat-button"
                onClick={() => this.props.history.push('/app/aiLlmAgent')}
              >
                🤖 AI Chat Assistant
              </Button>
            </div> */}
          </div>
        </div>
        <div className="nav-cards-container" >
          {cardData.map((card, index) => (
            <div className="nav-cards" key={index}>
              <div
                className="card-heading"
                dangerouslySetInnerHTML={{
                  __html: card.heading,
                }}
              ></div>
              <div className="card-description">{card.description}</div>
              <div className="card-bottom">

                <Button
                  color="primary"
                  className="get-started-button"
                  onClick={() => this.getStartedClicked(card.id)}
                >
                  Get Started
                </Button>

              </div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: "center", marginTop: "12px", marginBottom: "12px", flexShrink: 0 }}>
          <Button 
            color="primary" 
            style={{ borderRadius: "22px", padding: "8px 24px", fontSize: "16px", fontWeight: "600", display: "inline-flex", alignItems: "center" }} 
            onClick={() => eventEmitter.emit("openContactModal")}
          >
            <img src={contactus} alt="" style={{ width: "18px", marginRight: "8px", filter: "brightness(0) invert(1)" }} /> 
            Contact Us
          </Button>
        </div>

        <div className="landing-right" >
          <img src={dot1} alt="Decoration" />
        </div>
        <SweetAlert
          custom
          show={this.state.openErrorPopup}
          customButtons={<React.Fragment></React.Fragment>}
          style={{ width: "auto", padding: "1rem" }}
        >
          <ErrorPopup
            closeAlert={this.closePopup}
            title="Access to this feature is exclusive to Gold members. Please update your subscription to gain access."
            buttonTitle="Ok"
          ></ErrorPopup>
        </SweetAlert>


      </div>
    );
  }
}

export default connect(mapStateToProps)(LandingPage);
